import {CompanyGeneralInfoFormService} from "./company-general-info.form.service";
import {FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";
import {Product, StandardName} from "../../../../store/state/order.state";
import {UmbrellaValidators} from "../../../../umbrella-common/validation/umbrella-validators";
import {distinctUntilChanged, filter} from "rxjs/operators";
import {OrderActions} from "../../../../store/actions/order.actions";
import {AppState} from "../../../../store/state/app.state";
import {Store} from "@ngrx/store";
import {FormService} from "../../../../umbrella-common/services/form.service";
import {BaseFormControlHandler} from "./form-control.handler";
import {Injectable} from "@angular/core";

@Injectable()
export class ScopeDescriptionHandler extends BaseFormControlHandler {

	constructor(private fb: FormBuilder, private store: Store<AppState>) {
		super();
	}

	buildControls(form: FormGroup, product: Product) {
		const scopeDescriptionNeedsNarrowingControl = this.fb.control(product.scopeDescriptionNeedsNarrowing == null ? null : !product.scopeDescriptionNeedsNarrowing, UmbrellaValidators.radiobuttonRequired());
		form.addControl(`scopeDescriptionNeedsNarrowing${(product.standard.name)}`, scopeDescriptionNeedsNarrowingControl);
		this.addSubscription(product.standard.name, scopeDescriptionNeedsNarrowingControl.valueChanges
			.pipe(distinctUntilChanged(), filter(value => value != null))
			.subscribe((doesntNeedsNarrowing: boolean) => {
				this.store.dispatch(OrderActions.SET_SCOPE_DESCRIPTION_NEEDS_NARROWING({
					standardName: product.standard.name,
					needsNarrowing: !doesntNeedsNarrowing
				}));

				if (doesntNeedsNarrowing) {
					this.removeControlIfPresent(form, product.standard.name, 'scopeDescription');
					this.removeControlIfPresent(form, product.standard.name, 'employeesWithinScope');
				} else {
					this.addScopeDescriptionControl(form, product.standard.name, product.scopeDescription);
					this.addEmployeesWithinScopeControl(form, product.standard.name, product.employeesWithinScope);
				}
			}));

		if (product.scopeDescriptionNeedsNarrowing) {
			this.addScopeDescriptionControl(form, product.standard.name, product.scopeDescription);
			this.addEmployeesWithinScopeControl(form, product.standard.name, product.employeesWithinScope);
		}
	}

	protected fillProduct(formService: FormService, srcForm: string, product: Product): void {
		product.scopeDescriptionNeedsNarrowing = !formService.getValueFor('scopeDescriptionNeedsNarrowing', srcForm);
		product.scopeDescription = formService.getValueOrNull(srcForm, 'scopeDescription');
		product.employeesWithinScope = formService.getValueOrNull(srcForm, 'employeesWithinScope');
	}

	private addScopeDescriptionControl(form: FormGroup, standardName: StandardName, value: any) {
		const control = this.fb.control(value, [Validators.required, UmbrellaValidators.textLengthBetween(10, 5000)]);
		this.addSubscription(standardName, control.valueChanges.pipe(distinctUntilChanged())
			.subscribe((scopeDescription: string) => {
				this.store.dispatch(OrderActions.SET_SCOPE_DESCRIPTION({standardName, scopeDescription}));
			}));

		form.addControl(`scopeDescription${standardName}`, control);
	}

	private addEmployeesWithinScopeControl(form: FormGroup, standardName: StandardName, value: any) {
		const validators = [Validators.required, UmbrellaValidators.minInteger(1), Validators.max(CompanyGeneralInfoFormService.MAX_NUMBER_OF_EMPLOYEES), this.notHigherThatTotalEmployees(form, standardName)];
		const control = this.fb.control(value, validators);
		this.addSubscription(standardName, control.valueChanges.pipe(distinctUntilChanged()).subscribe((employees: number) => this.store.dispatch(OrderActions.SET_EMPLOYEES_WITHIN_SCOPE({standardName, employees}))));
		form.addControl(`employeesWithinScope${standardName}`, control);
	}

	private notHigherThatTotalEmployees(form: FormGroup, formKey: string): ValidatorFn {
		return control => {
			const totalEmployees = form.controls[`employeesCount${formKey}`].value;
			if (totalEmployees == null || control.value == null) {
				return null;
			}

			return  control.value > totalEmployees ?
				{employeeWithinScopeToHigh: []} as ValidationErrors :
				null;
		};
	}
}
